import { SignalKindsToInclude } from '../../../constants/SignalsKinds';
import { checkSignalKinds } from './RangeUtilities';
export function checkRangeKind(range) {
    return range.signals && checkSignalKinds(range, SignalKindsToInclude);
}
//# sourceMappingURL=checkRangeKind.js.map